module.exports = __webpack_public_path__ + "img/sougoushuru.dd65001c.png";